import { Separator, Button } from '@/ui'

export const CalculateSafeHarborFooter = ({
  goToPreviousStep,
  submitOrContinue,
  continueDisabled,
  loading,
  nextText = 'Continue',
}: {
  goToPreviousStep: () => void
  submitOrContinue: () => void
  continueDisabled?: boolean
  loading?: boolean
  nextText?: string
}) => (
  <>
    <Separator />
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
      <Button
        className="w-full sm:w-1/2"
        onClick={() => goToPreviousStep()}
        variant="secondary"
      >
        Back
      </Button>
      <Button
        className="w-full sm:w-1/2"
        onClick={submitOrContinue}
        disabled={continueDisabled}
        loading={loading}
      >
        {nextText}
      </Button>
    </div>
  </>
)
